module.exports = __webpack_public_path__ + "img/cmp_bg_public@3x.cc5da6aa.png";